import { transpileBlock } from "./scratchTranspiler";

export const convertScratchToArduino = (projectData) => {
  try {
    let projectObj = projectData;
    if (typeof projectData === "string") {
      if (!projectData.trim()) {
        projectObj = null;
      } else {
        try {
          projectObj = JSON.parse(projectData);
        } catch (e) {
          projectObj = null;
        }
      }
    }

    if (!projectObj || !projectObj.targets) {
      return `#include <Arduino.h>

void setup() {
  Serial.begin(9600);
}

void loop() {
  delay(100);
}
`;
    }

    const allUsedMethods = new Set();
    const rawLines = [];

    projectObj.targets.forEach((target) => {
      const spriteName = target.name || "Sprite1";
      const cleanVarName = spriteName.toLowerCase().replace(/[^a-z0-9_]/g, "_");

      if (target.blocks) {
        const blocks = target.blocks;
        const topBlockKeys = Object.keys(blocks).filter(
          (k) => typeof blocks[k] === "object" && blocks[k].topLevel
        );

        topBlockKeys.forEach((topKey) => {
          const ctx = {
            targetLang: "arduino",
            varName: cleanVarName,
            indentLevel: 1,
            baseIndent: 1,
            lines: rawLines,
            usedMethods: allUsedMethods,
          };
          transpileBlock(topKey, blocks, ctx);
        });
      }
    });

    let cppLines = [
      "#include <Arduino.h>",
      "",
    ];

    const setupBodyLines = [];
    const loopBodyLines = [];

    rawLines.forEach((line) => {
      const trimmed = line.trim();
      if (
        trimmed === "void setup() {" ||
        trimmed === "void setup () {" ||
        trimmed === "void loop() {" ||
        trimmed === "}" ||
        trimmed.includes("Practido Arduino Hardware")
      ) {
        return;
      }

      if (trimmed.startsWith("while (true)") || trimmed.includes("while (true)") || trimmed.includes("loop")) {
        loopBodyLines.push(line.startsWith("  ") ? line : `  ${line}`);
      } else {
        setupBodyLines.push(line.startsWith("  ") ? line : `  ${line}`);
      }
    });

    cppLines.push("void setup() {");
    cppLines.push("  Serial.begin(9600);");
    if (setupBodyLines.length > 0) {
      cppLines.push(...setupBodyLines);
    }
    cppLines.push("}");
    cppLines.push("");

    cppLines.push("void loop() {");
    if (loopBodyLines.length > 0) {
      cppLines.push(...loopBodyLines);
    } else {
      cppLines.push("  delay(100);");
    }
    cppLines.push("}");

    return cppLines.join("\n");
  } catch (err) {
    return `// Error transpiling Scratch to Arduino C++: ${err.message}`;
  }
};

